import { useState } from "react";
import styled from "styled-components";
import ArrowOpen from "../../../assets/svg/arrow_down_small.svg?react";
import { getCompletedArticlesProps } from "./TestBuyDetailsHelper";
import { Trans } from "@coworker/locales";
import { TestbuyItemsListView } from "@coworker/apprestructured/src/testbuy/components/TestbuyItemsListView/TestbuyItemsListView";
import { TestbuyItems } from "@coworker/apprestructured/src/testbuy/types/testbuyItems";
import {
  TestBuy,
  TestBuyProductWithCriteria,
} from "@coworker/types/lib/testbuy";

const ShowCompletedListContainer = styled("div")`
  display: flex;
  flex-direction: row;
  padding: 1rem 1.5rem 1rem 2rem;
  border-bottom: 1px solid var(--grey150);
  border-top: 1rem solid var(--grey150);
`;

const ToggleIcon = styled("div")`
  margin-left: auto;
`;
const ArrowClosed = styled(ArrowOpen)`
  transform: rotate(180deg);
  transform-origin: center;
`;

interface CompletedArticlesProps extends TestbuyItems {
  testbuy: TestBuy;
}

export default function CompletedArticleList({
  testbuyItems,
  testbuy,
}: CompletedArticlesProps) {
  const [shouldShowCompletedTasks, setShouldShowCompletedTasks] =
    useState(false);

  const completeArticlesProps = getCompletedArticlesProps(testbuyItems);
  return (
    //This div exist due to render issues on RDT
    <div data-testid="completed-article-list">
      <ShowCompletedListContainer
        onClick={() => {
          setShouldShowCompletedTasks(!shouldShowCompletedTasks);
        }}
      >
        <p>
          {shouldShowCompletedTasks ? (
            <Trans count={completeArticlesProps.testbuyItems.length}>
              hideCompleted
            </Trans>
          ) : (
            <Trans count={completeArticlesProps.testbuyItems.length}>
              showCompleted
            </Trans>
          )}
        </p>
        <ToggleIcon>
          {shouldShowCompletedTasks ? <ArrowOpen /> : <ArrowClosed />}
        </ToggleIcon>
      </ShowCompletedListContainer>
      {shouldShowCompletedTasks && (
        <TestbuyItemsListView
          isItemCompletedInTestbuy
          testbuy={testbuy}
          filteredTestbuyItems={completeArticlesProps.testbuyItems}
          allTestbuyItemNos={testbuyItems.map(
            (item: TestBuyProductWithCriteria) => item.shortId
          )}
        />
      )}
    </div>
  );
}
